import { Drawer, styled } from '@mui/material';

export const DesktopDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'drawerOpen',
})<{ drawerOpen: boolean }>(({ drawerOpen }) => ({
  '& .MuiDrawer-paper': {
    border: 'none',
    padding: '0',
    overflow: 'visible',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: drawerOpen ? '320px' : '72px',
    transition: 'width 200ms ease',
  },
}));

export const SearchBarWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  padding: '0 16px 12px',
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

export const MenuWrapper = styled('div')(({ theme }) => ({
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: '8px 8px 12px',
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.action.disabled} transparent`,
  '::-webkit-scrollbar': {
    width: '8px',
  },
  '::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.action.disabled,
    borderRadius: '4px',
  },
  '::-webkit-scrollbar-track': {
    background: 'transparent',
  },
}));

export const Header = styled('div', {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open: boolean }>(({ theme, open }) => ({
  height: '64px',
  padding: open ? '0 20px' : '0 8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: open ? 'space-between' : 'center',
  gap: open ? '12px' : '4px',
  flexShrink: 0,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: open ? 'transparent' : theme.palette.action.hover,
  },
  '& > img': {
    flexShrink: 0,
    height: open ? '28px' : '24px',
    width: 'auto',
    maxWidth: open ? '160px' : '24px',
    objectFit: 'contain',
  },
  '& > h5': {
    opacity: open ? 1 : 0,
    visibility: open ? 'visible' : 'hidden',
    transition: 'opacity 200ms ease, visibility 200ms ease',
    maxWidth: open ? '100%' : 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    color: theme.palette.text.primary,
    fontSize: '15px',
    fontWeight: 600,
    lineHeight: '22px',
  },
}));

export const ToggleButton = styled('div', {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open?: boolean }>(({ theme, open }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: open ? '36px' : '28px',
  height: open ? '36px' : '28px',
  borderRadius: '8px',
  flexShrink: 0,
  cursor: 'pointer',
  color: theme.palette.text.secondary,
  transition: 'background-color 150ms ease, color 150ms ease',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary,
  },
  '& > button': {
    width: open ? '24px' : '20px',
    height: open ? '24px' : '20px',
  },
}));
